import React from "react";
import "./socialSignalCardSkeleton.css";

const SocialSignalCardSkeleton: React.FC = () => {
  return (
    <div className="social-signal-card-skeleton">
      <div className="skeleton-header">
        <div className="skeleton-platform-info">
          <div className="skeleton-icon"></div>
          <div className="skeleton-source"></div>
        </div>
        <div className="skeleton-timestamp"></div>
      </div>

      <div className="skeleton-title"></div>
      <div className="skeleton-content">
        <div className="skeleton-line"></div>
        <div className="skeleton-line"></div>
        <div className="skeleton-line short"></div>
      </div>

      <div className="skeleton-intent"></div>

      <div className="skeleton-footer">
        <div className="skeleton-stats"></div>
        <div className="skeleton-actions">
          <div className="skeleton-button"></div>
          <div className="skeleton-button"></div>
        </div>
      </div>
    </div>
  );
};

export default SocialSignalCardSkeleton;
